import { render, staticRenderFns } from "./MarketplaceArticle.vue?vue&type=template&id=2802d62d&"
import script from "./MarketplaceArticle.vue?vue&type=script&lang=js&"
export * from "./MarketplaceArticle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports